import { render } from "./SelectLanguageInput.vue?vue&type=template&id=32d20932"
import script from "./SelectLanguageInput.vue?vue&type=script&lang=js"
export * from "./SelectLanguageInput.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__